import React, { useState } from 'react';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
interface ContactFormData {
  name: string;
  email: string;
  phone: string;
  role: string;
}
interface AddContactModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (contact: ContactFormData) => void;
}
export function AddContactModal({
  isOpen,
  onClose,
  onSave
}: AddContactModalProps) {
  const [formData, setFormData] = useState<ContactFormData>({
    name: '',
    email: '',
    phone: '',
    role: ''
  });
  const handleSave = () => {
    onSave(formData);
    onClose();
    setFormData({
      name: '',
      email: '',
      phone: '',
      role: ''
    });
  };
  return <Modal isOpen={isOpen} onClose={onClose} title="Add Contact" size="sm" footer={<>
          <Button variant="outline" onClick={onClose} data-id="element-110">
            Cancel
          </Button>
          <Button onClick={handleSave} data-id="element-111">Add Contact</Button>
        </>} data-id="element-109">
      <div className="space-y-4" data-id="element-112">
        <Input label="Name" value={formData.name} onChange={e => setFormData(prev => ({
        ...prev,
        name: e.target.value
      }))} placeholder="Jane Smith" data-id="element-113" />

        <Input label="Email" type="email" value={formData.email} onChange={e => setFormData(prev => ({
        ...prev,
        email: e.target.value
      }))} placeholder="jane@school.edu" data-id="element-114" />

        <Input label="Phone" type="tel" value={formData.phone} onChange={e => setFormData(prev => ({
        ...prev,
        phone: e.target.value
      }))} placeholder="(555) 123-4567" data-id="element-115" />

        <Input label="Role" value={formData.role} onChange={e => setFormData(prev => ({
        ...prev,
        role: e.target.value
      }))} placeholder="e.g., Athletic Director" data-id="element-116" />
      </div>
    </Modal>;
}